export const numbersOnly = (value: string) => {
  if (!value.trim()) return null;
  return value.replace(/\D/g, '');
};
